import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Flex } from 'reflexbox';

import {
  If,
  WowIcon,
} from 'frontend/components';

const UpgradeCost = ({ costs }) => (
  <Flex ml={1}>
    {_.map(costs, cost => (
      <Flex ml={1} align="center" key={cost.currencyId || cost.itemId}>
        <WowIcon
          size={14}
          id={cost.currencyId || cost.itemId}
          type={cost.currencyId ? 'currency' : 'item'}
          icon={cost.icon}
          noLink
        />
        {cost.amount}
        <If
          condition={cost.alternateItemId}
          then={() => (
            <>
              &nbsp;
              (or&nbsp;
              <WowIcon
                size={14}
                id={cost.alternateItemId}
                type="currency"
                icon={cost.alternateItemIcon}
                noLink
              />
              {cost.amount * cost.alternateItemAmount}
              )
            </>
          )}
        />
      </Flex>
    ))}
  </Flex>
);

UpgradeCost.propTypes = {
  costs: PropTypes.array.isRequired,
};

export default UpgradeCost;
